import React from 'react';
import { PaymentElement, useCheckout } from '@stripe/react-stripe-js';
import { LeftArrowIcon, RightArrowIcon } from '../Common/SVGBank';
import PaymentErrorModal from './PaymentErrorModal';

export const CheckoutForm = ({ previousStep, mobile, email, }) => {
    const { confirm, canConfirm } = useCheckout();
    const [showErrorModal, setShowErrorModal] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState('');

    const book = () => {
        confirm({ email: email }).then((result) => {
            if (result.type === 'error') {
                // Handle Stripe payment errors
                const errorMsg = result.error?.message || 'Payment failed. Please check your payment information and try again.';
                setErrorMessage(errorMsg);
                setShowErrorModal(true);
            }
        }).catch((error) => {
            // Handle any other errors during payment processing
            const errorMsg = error?.message || 'An unexpected error occurred during payment. Please try again.';
            setErrorMessage(errorMsg);
            setShowErrorModal(true);
        });
    }

    return (
        <div>
            <PaymentErrorModal
                isOpen={showErrorModal}
                onClose={() => setShowErrorModal(false)}
                errorMessage={errorMessage}
                errorTitle="Payment Failed"
            />

            <form>
                <PaymentElement options={{ layout: 'tabs' }} />
            </form>

            <div>
                <div style={{ marginBottom: 20 }}>
                    <button className='recapButtons' style={{ background: mobile ? 'transparent' : '#DFDFDF', width: mobile ? "48%" : "200px" }} onClick={previousStep}>
                        <LeftArrowIcon fill={'#7F7F7F'} height={14} width={14} style={{ marginRight: 10 }} /> Previous step
                    </button>


                    <div style={{ float: "right" }}>
                        <button className='recapButtons' style={{ opacity: 1, background: '#19BC9B', color: 'white', font: '14px/14px Futura Hv BT', width: mobile ? "180px" : "200px" }} onClick={book}>
                            Book <RightArrowIcon height={14} width={14} style={{ marginLeft: mobile ? 40 : 90 }} />
                        </button>
                    </div>

                </div>

            </div>
        </div>
    );
};